import React, { Component, useMemo } from 'react';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import Moment from 'react-moment';
import { Alert, UncontrolledDropdown, Modal, ModalBody } from 'reactstrap';
import ReceptionistTabs from './partials/tabs';
import Loader from './../../components/snippets/loader';
import HebrewDate from './../../components/hebrewDate';
import ReactSVG from 'react-svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getUserByPhone, changeExcludedAttendants, getUser, patchUser, getUserMembership, userMembership } from "./../../models/user";
import { getReservationsByUser } from './../../models/reservation';
import { createPayment, getSavedCards, deleteSavedCard, getPaymentsByUser } from "./../../models/payment";
import { getMembershipLevels } from '../../models/setting';
import { getAttendants } from './../../models/attendant';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { cardBrands, statuses, languages } from './../../global-props';
import { localProps } from '../../../localmikvah/local-props';
import StripeProvider from './../../components/stripeProvider';
import StripeTerminal from './../../components/stripeTerminal';
import StripeCardForm from './../../components/stripeCardForm';
import { SettingsContext } from "./../../components/context";
import CurrencyFormat from './../../components/snippets/currency-format';
import Button from './../../components/button';
import NumberFormat from "react-number-format";
import ReservationDetails from './partials/reservation-details';
import SignalR from './../../components/signalr';
import { Link } from 'react-router-dom';
import i18n from './../../i18n';
import { useTable, useSortBy } from 'react-table';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';
import iconWalkin from "../../assets/images/icon-walkin.svg";
import iconExcludedAttendant from "../../assets/images/icon-excluded-attendant.svg";
import iconBathPrivate from '../../assets/images/icon-bath-private.svg';
import iconShowerPrivate from '../../assets/images/icon-shower-private.svg';
import iconSegula from '../../assets/images/icon-segula.svg';

class ReceptionistUserView extends Component {
  static contextType = SettingsContext;

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      membershipError: null,
      emailFormError: null,
      userResults: null,
      firstName: '',
      lastName: '',
      email: '',
      isUserResultsOpen: false,
      enteredPhone: '',
      plateNumber: "",
      selectedPaymentItem: null,
      otherPaymentItem: '',
      creditMode: null,
      user: null,
      savedCards: null,
      isLoadingSavedCards: false,
      paymentReference: '',
      selectedReservation: null,
      activeUserResult: 0,
      modalDeleteCard: false,
      modalLicensePLate: false,
      modalUserName: false,
      modalUserEmail: false,
      overrideMaxExcluded: false,
      membership: {},
      localResident: false,
      isSavingLocalResident: false
    };

    this.toggleUserResults = this.toggleUserResults.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeMembership = this.handleChangeMembership.bind(this);
    this.handleChangePhone = this.handleChangePhone.bind(this);
    this.handleGetSavedCards = this.handleGetSavedCards.bind(this);
  }

  componentDidMount() {
    if (this.props.userId) {
      this.retrieveUserById(this.props.userId);
    } else {
      this.setState({isLoaded: true});
    } 
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props && !this.props.userId ) {
      this.setState({user:null, enteredPhone: '', userResults: null, plateNumber:''})
    }
  }

  retrieveReservations(hideLoader=false) {
    if (!hideLoader) {this.setState({isLoadingReservations: true});}
    let userId = this.state.user?this.state.user.id:null;
    let dateFrom = moment('2019-01-01').format('YYYY-MM-DD');
    if (!userId) return;
    getReservationsByUser(userId, dateFrom)
      .then(
        result => {
          let reservations = result;
          this.setState({
            reservations: reservations,
            isLoadingReservations: false,
          });
        },
        error => {
          console.log(error);
          this.setState({
            isLoadingReservations: false,
            error
          });
        }
      );
  }

  retrievePayments(hideLoader=false) {
    if (!hideLoader) {this.setState({isLoadingPayments: true});}
    let userId = this.state.user?this.state.user.id:null;
    let dateFrom = moment('2019-01-01').format('YYYY-MM-DD');
    if (!userId) return;
    getPaymentsByUser(userId, dateFrom)
      .then(
        result => {
          let payments = result;
          this.setState({
            payments: payments,
            isLoadingPayments: false,
          });
        },
        error => {
          console.log(error);
          this.setState({
            isLoadingPayments: false,
            error
          });
        }
      );
  }

  retrieveAttendants() {
    this.setState({isLoadingAttendants: true})
    getAttendants(true)
      .then(result => {
        let attendants = result;
        this.setState({
          attendants,
          isLoadingAttendants: false,
        })
      }, error => {
        this.setState({error, isLoadingAttendants: false});
      });
  }

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    let value = target.type === 'checkbox' ? target.checked : target.value;

    this.setState({[name]: value});
    if (name.substring(0,12)==='notification') { this.handleSaveNotification(name, value) }
    if (name === "localResident") { this.handleSaveLocalResident(value) }
  }

  handleChangePhone(e) {
    let numberLength = 15;
    let value = e.target.value;
    value = value.slice(0,numberLength);

    this.setState({ enteredPhone: value, userResults: null, error: null })
    if ( value.length >= 4) {
      getUserByPhone(value)
      .then(
        result => {
          this.setState({
            userResults: result,
            isUserResultsOpen: true,
          })
        },
        error => {
          this.setState({
            error: error
          });
        }
      );
      
    }
  }

  handleChangeMembership(event) {
    const target = event.target;
    const name = target.name;
    if(name==='membershipLevel'){
      this.calculateDefaultMembershipPricing(event)
    }
    let value = target.type === 'checkbox' ? target.checked : target.value;
    let updateMembership = {...this.state.updateMembership}
    updateMembership[name] = value
    this.setState({updateMembership});
  }

  retrieveUserById(userId) {
    getUser(userId)
      .then(result=>this.handleSelectUser(result));
  }

  retrieveUserMembership() {
    const { user } = this.state;
    getUserMembership(user.id)
      .then(result=>{
        if(result.membershipLevel){
          this.calculateDefaultMembershipPricing(null,result.membershipLevel);
        }
        this.setState({membership: result, updateMembership: result})
      });
  }

  retrieveMembershipLevels() {
    getMembershipLevels()
      .then(result=>this.setState({membershipLevels: result},this.retrieveUserMembership));
  }

  calculateDefaultMembershipPricing(e, level) {
    const selectedLevel = level||e.target.value;
    const siteLevel = this.state.membershipLevels.find(level => level.level==selectedLevel)||null;
    this.setState({ siteMembershipLevel: siteLevel});
  } 

  handleSelectUser(user) {
    if(!this.props.userId){
      this.props.history.push('/receptionist/user/'+user.id);
    } else {
      if (user) {
        this.setState({ enteredPhone: user.phoneNumber, localResident: user.localResident, user: user, firstName: user.firstName, lastName: user.lastName, email: user.email, isLoaded: true }, () => {
          this.retrieveReservations();
          this.handleGetSavedCards();
          this.retrieveAttendants();
          this.retrievePayments();
          this.retrieveMembershipLevels();
        });      
      }
    }
  }

  handleRefreshUser(userId) {
    getUser(userId)
      .then(result => this.setState({user: result}), error => this.setState({error}))
  }

  toggleUserResults() {
    this.setState({isUserResultsOpen: !this.state.isUserResultsOpen});
  }

  handleGetSavedCards() {
    if (this.state.user) {
      this.setState({isLoadingSavedCards:true});
      getSavedCards(this.state.user.id)
        .then(result => {
          this.setState({
            savedCards: result,
            isLoadingSavedCards: false,
          })
        }, error => this.setState({error, isLoadingSavedCards: false}))
    }
  }

  startOver = () => {
    this.setState({
      user:null,
      enteredPhone: null
    });
  }

  viewReservation = (resId) => {
    this.setState({selectedReservation: this.state.reservations.findIndex(res=>res.reservationId===resId), modalReservation: true});
  }

  handleReservationUpdated(res) {
    let reservations = this.state.reservations;
    reservations[this.state.selectedReservation] = res;
    this.setState({reservations})
  }

  handleKeyDown = e => {
    const { activeUserResult, userResults } = this.state;

    if (userResults) {
      if (e.keyCode===13) {
        this.handleSelectUser(userResults[activeUserResult]);
        this.setState({
          activeUserResult: 0,
          isUserResultsOpen: false,      
        })
      } else if (e.keyCode===38) {
        if (activeUserResult===0) return;
        this.setState({activeUserResult: activeUserResult - 1});
      } else if (e.keyCode===40) {
        if (activeUserResult-1===userResults.length) return;
        this.setState({activeUserResult: activeUserResult + 1});
      }      
    }
  }

  modalToggleDeleteCard = () => {
    this.setState({modalDeleteCard: !this.state.modalDeleteCard});
  }

  handleDeleteSavedCard = () => {
    this.setState({isSavingCards: true})
    deleteSavedCard(this.state.user.id, this.state.selectedDeleteCard.id)
      .then(result => {
        this.modalToggleDeleteCard();
        this.setState({isSavingCards: false, savedCards: result,})
      }, error => {
        this.setState({error, isSavingCards: false})
      });
  }

  modalToggleRemoveAttendant = () => {
    this.setState({modalRemoveAttendant: !this.state.modalRemoveAttendant});
  }

  handleRemoveAttendant = () => {
    const { user, selectedRemoveAttendant } = this.state;
    this.setState({isSavingAttendant: true})
    changeExcludedAttendants(user.id, selectedRemoveAttendant.id, 'delete')
      .then(result => {
        this.handleRefreshUser(user.id);
        this.modalToggleRemoveAttendant();
        this.setState({isSavingAttendant: false, overrideMaxExcluded:false})
      }, error => {
        this.setState({error, isSavingAttendant: false})
      })
  }

  modalToggleAddAttendant = () => {
    this.setState({modalAddAttendant: !this.state.modalAddAttendant, selectedAddAttendant: null});
  }

  handleAddAttendant = () => {
    const { selectedAddAttendant, user } = this.state;
    this.setState({isSavingAttendant: true})
    changeExcludedAttendants(user.id, selectedAddAttendant.id)
      .then(result => {
        this.handleRefreshUser(user.id);
        this.modalToggleAddAttendant();
        this.setState({isSavingAttendant: false,overrideMaxExcluded:false})
      }, error => {
        this.setState({error, isSavingAttendant: false})
      })
  }

  modalToggleUserNote = () => {
    let { userNote, user } = this.state;
    if (!userNote) { userNote = user.notes }
    this.setState({modalUserNote: !this.state.modalUserNote, userNote});
  }

  modalToggleInternalNote = () => {
    let { internalNote, user } = this.state;
    if (!internalNote) { internalNote = user.internalNote }
    this.setState({modalInternalNote: !this.state.modalInternalNote, internalNote});
  }

  modalToggleLicensePLate = () => {
    let { plateNumber, user } = this.state;
    if (!plateNumber) { plateNumber = user.plateNumber }
    this.setState({modalLicensePLate: !this.state.modalLicensePLate, plateNumber});
  }

  modalToggleMembership = () => {
    this.setState({modalMembership: !this.state.modalMembership});
  }

  modalToggleUserName = () => {
    this.setState({modalUserName: !this.state.modalUserName});
  }
  modalToggleUserEmail = () => {
    this.setState({modalUserEmail: !this.state.modalUserEmail});
  }

  handleSaveMembership = () => {
    const { updateMembership, user } = this.state;
    this.setState({isSavingMembership: true});
    userMembership(user.id, updateMembership)
      .then(result => {
        this.modalToggleMembership();
        this.setState({
          isSavingMembership: false,
          membershipError: null
        })
        this.retrieveUserMembership(user.id)
      }, error => {
        this.setState({membershipError: error, isSavingMembership: false})
      })
  }

  handleSaveNote = () => {
    const { user, userNote } = this.state;
    this.setState({isSavingNote: true});
    patchUser(user.id, [{"op": "add", "path": "/Notes", "value": userNote }])
      .then(result => {
        let user = result.result;
        this.modalToggleUserNote();
        this.setState({
          isSavingNote: false,
          user
        })
      }, error => {
        this.setState({error, isSavingNote: false})
      })
  }

  handleSaveInternalNote = () => {
    const { user, internalNote } = this.state;
    this.setState({isSavingInternalNote: true});
    patchUser(user.id, [{"op": "add", "path": "/InternalNote", "value": internalNote }])
      .then(result => {
        let user = result.result;
        this.modalToggleInternalNote();
        this.setState({
          isSavingInternalNote: false,
          user
        })
      }, error => {
        this.setState({error, isSavingNote: false})
      })
  }

  handleSavePlate = () => {
    const { user, plateNumber } = this.state;
    this.setState({isSavingPlate: true});
    let modNum = plateNumber.split("\n").join("|")
    patchUser(user.id, [{"op": "add", "path": "/plateNumber", "value": modNum }])
      .then(result => {
        let user = result.result;
        this.modalToggleLicensePLate();
        this.setState({
          isSavingPlate: false,
          user,
          plateNumber:user.plateNumber
        })
      }, error => {
        this.setState({error, isSavingPlate: false})
      })
  }

  handleSaveNotification = (name, value) => {
    const { user } = this.state;
    patchUser(user.id, [{"op": "add", "path": "/"+name, "value": value }])
      .then(result => {
        let user = result.result;
        this.setState({
          isSavingNotification: false,
          user
        })
      }, error => {
        this.setState({error, isSavingNotification: false})
      })
  }

  handleSaveLangauge = (lang) => {
    const { user } = this.state;
    this.setState({isSavingLanguage: true});
    patchUser(user.id, [{"op": "add", "path": "/Language", "value": lang.name }])
      .then(result => {
        let user = result.result;
        this.setState({
          isSavingLanguage: false,
          user
        })
      }, error => {
        this.setState({error, isSavingLanguage: false})
      })
  }

  handleSaveName = () => {
    const { user, firstName, lastName } = this.state;
    this.setState({isSavingName: true});
    patchUser(user.id, [{"op": "add", "path": "/FirstName", "value": firstName }, {"op": "add", "path": "/LastName", "value": lastName }])
      .then(result => {
        let user = result.result;
        this.setState({
          isSavingName: false,
          user
        })
        this.modalToggleUserName();
      }, error => {
        this.setState({error, isSavingName: false})
      })
  }

  handleSaveEmail = () => {
    const { user, email } = this.state;
    let emailValid = email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    if(emailValid){
      this.setState({emailFormError: null, isSavingEmail: true});
      patchUser(user.id, [{"op": "add", "path": "/email", "value": email }])
        .then(result => {
          let user = result.result;
          this.setState({
            isSavingEmail: false,
            user
          })
          this.modalToggleUserEmail();
        }, error => {
          this.setState({emailFormError: error, isSavingEmail: false})
        })
    } else {
      this.setState({emailFormError: "Please enter a valid email."})
    }
  }

  handleSaveLocalResident = (value) => {
    const { user } = this.state;
    patchUser(user.id, [{"op": "add", "path": "/localResident", "value": value }])
      .then(result => {
        let user = result.result;
        this.setState({
          localResident: user.localResident,
          isSavingLocalResident: false,
        })
      }, error => {
        this.setState({error, isSavingLocalResident: false})
      })
  }

  render() {
    const { t, siteSettings } = this.props;
    const { error, isLoaded, emailFormError, enteredPhone, userResults, isUserResultsOpen, user, isLoadingSavedCards, savedCards, isLoadingAttendants, attendants, isLoadingReservations, reservations, isLoadingPayments, payments, selectedReservation, activeUserResult, isSavingAttendant, isSavingNote, isSavingInternalNote, isSavingPlate, plateNumber, overrideMaxExcluded, isSavingCards, userNote, internalNote, isSavingNotification, isSavingLanguage, membershipError, modalMembership, updateMembership, membership, membershipLevels, siteMembershipLevel, isSavingMembership, modalUserName, modalUserEmail, isSavingName, isSavingEmail, firstName, lastName, email, localResident, isSavingLocalResident } = this.state;
    const currentPageName = "Patrons";
    const { settings } = this.context;
    const displayedLanguages = (localProps&&localProps.languages)||languages;
    return (
      <div className={'container-page view-user lang-' + i18n.language}>
        <SignalR setReception={true} onReservationsUpdated={() => this.retrieveReservations(true)} onCubiclesUpdated={() => this.retrieveReservations(true)} />
        <div className="container-main">
          <div className="container-body reception-background">
            <ReceptionistTabs page={currentPageName} siteSettings={siteSettings} />
            {error!==null?
              <Alert color="danger">{t(error)} <span className="alert-link mis-2" onClick={()=>window.location.reload()}>{t("Try again")}</span></Alert>
            :null}
            {isLoaded?
            <>
            {!user?
              <div className="container-checkin">
                <div className="modal-header">
                  <div className="header-title"><h4>{t("Patrons")}</h4></div>
                </div>
                <div className="modal-body">
                  <div className="mx-auto w-100 text-center">
                    <div className="checkin-numbers w-75 mx-auto mb-4">
                      <div className="title mb-3">{t("Enter the last 4 digits of guest's phone number")}</div>
                      <form autoComplete="off" onSubmit={(e)=>e.preventDefault()}>
                        <Dropdown inNavbar isOpen={isUserResultsOpen} toggle={this.toggleUserResults}>
                          <NumberFormat
                            className="form-control number-input"
                            type="tel"
                            name="phoneNumber"
                            decimalScale={0}
                            allowNegative={false}
                            placeholder="0000"
                            value={enteredPhone}
                            onChange={this.handleChangePhone}
                            onClick={()=>this.setState({isUserResultsOpen:true})}
                            onKeyDown={this.handleKeyDown}
                            autoFocus={true}
                          />
                          <DropdownToggle tag="span"></DropdownToggle>
                          {userResults&&userResults.length?
                            <DropdownMenu>
                              {userResults.map((s,i)=>
                                <DropdownItem key={i} active={i===activeUserResult} className="d-flex justify-content-between" onClick={()=>this.handleSelectUser(s)}>
                                  <div>{t("Patron Id")}: {s.id}</div>
                                  <div>{s.phoneNumber}</div>
                                </DropdownItem>
                              )}
                            </DropdownMenu>
                          :null}              
                        </Dropdown>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            :
              <>
                <div className="row reception-view">
                  <div className="col-8">
                    {isLoadingReservations?
                      <Loader />
                    :
                      reservations?
                      <>
                      <h3>{t("Reservations")}</h3>
                      <ReservationsTable attendants={attendants} data={reservations} t={t} viewReservation={this.viewReservation}/>
                      </>
                      :null
                    }
                    {isLoadingPayments && isLoadingReservations?
                      <Loader />
                    :
                    <>
                    <h3>{t("Payments")}</h3>
                      {payments && payments.length?
                        <table className="table text-start">
                          <thead>
                            <tr>
                              <th>{t("Time")}</th>
                              <th>{t("Method")}</th>
                              <th>{t("Status")}</th>
                              <th>{t("Details")}</th>
                              <th className="text-end">{t("Amount")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {payments.map((payment,i) => {
                              return <tr className={payment.reservationID?"clickable":""} onClick={() => payment.reservationID?this.viewReservation(payment.reservationID):null} key={i}>
                                <td>
                                  <Moment format={t("MM/DD/YY")}>{payment.dateCreated}</Moment>
                                  <HebrewDate className="mis-1" date={payment.dateCreated} day={true} month={true}/>
                                </td>
                                <td>{t(payment.method)} {payment.method==='Fee' && payment.note?' - ' + payment.note:null}{payment.method==='Tip'?(payment.tipNote?' - ' + t(payment.tipNote):' - ' + t("General")):null}{payment.method==='CreditCard'&&payment.transactionID&&(settings && settings.ccProcessorType && settings.ccProcessorType.value==='stripe')?<a href={"https://dashboard.stripe.com/payments/"+payment.transactionID} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon="file-invoice-dollar" className="mis-2" /></a>:null}</td>
                                <td>{t(payment.status)} {payment.status==='Approved'?<FontAwesomeIcon icon="check" className="mis-2" />:null}{payment.status==='Error'||payment.status==='Declined'? " - " + payment.error:null}</td>
                                <td>{t(payment.reference)}</td>
                                <td className="text-end"><CurrencyFormat value={payment.amount} /></td>
                              </tr>
                            })}
                          </tbody>
                        </table>
                      :<Alert className="mt-3 m-2 text-center" color="warning">{t("There are no payments for this patron.")}</Alert>
                      }
                    </>
                    }
                  </div>
                  <div className="col-4 font-weight-normal">
                    <div className="card mb-3">
                      <div className="card-body pb-0 border-bottom d-flex justify-content-between align-items-center">
                        <h5 className="card-title">{t("Patron Info")} {user.phoneNumber.slice(-10)==='0000000000'?' - ' + t("Guest Patron"):''}</h5>
                        <UncontrolledDropdown>
                          <DropdownToggle className="btn btn-sm" tag="div"><FontAwesomeIcon icon="ellipsis-v" /></DropdownToggle>
                          <DropdownMenu right>
                            <DropdownItem tag={Link} to={{pathname: "../checkin/", state: { userId: user.id }}}>{t("Create Walk In")}</DropdownItem>
                            <DropdownItem tag={Link} to={{pathname: "../reservation/", state: { userId: user.id }}}>{t("Create Reservation")}</DropdownItem>
                            <DropdownItem tag={Link} to={{pathname: "../payment/", state: { userId: user.id }}}>{t("Create Payment")}</DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                      <ul className="pis-0 list-group list-group-flush">
                        <li className="list-group-item d-flex flex-wrap justify-content-between align-items-center">
                          <div>{t("Name")}</div>
                          <div className="d-flex align-items-center">
                            <span>{user.firstName} {user.lastName}</span>
                            <Button className="ml-1 btn-sm" onClick={this.modalToggleUserName}><FontAwesomeIcon icon={user.firstName || user.lastName?['far', 'edit']:'plus'} /></Button>
                          </div>
                        </li>
                        <li className="list-group-item d-flex flex-wrap justify-content-between align-items-center">
                          <div>{t("Email")}</div>
                          <div className="d-flex align-items-center">
                            <span>{user.email}</span>
                            <Button className="ml-1 btn-sm" onClick={this.modalToggleUserEmail}><FontAwesomeIcon icon={user.email?['far', 'edit']:'plus'} /></Button>
                          </div>                        
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <div>{t("Patron Id")}</div>
                          <div>{user.id}</div>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <div>{t("Patron Code")}</div>
                          <div>{user.phoneNumber&&user.phoneNumber.slice(user.phoneNumber.length - 4)}</div>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <div>{t("Phone")}</div>
                          <div>{user.phoneNumber}</div>
                        </li>
                        {user.phoneNumber.slice(-10)!=='0000000000'?
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <div>{t("Local Resident")}</div>
                          {isSavingLocalResident?
                              <Loader className="mis-3" />
                            :
                              <div className="form-check form-switch mis-3">
                                <input type="checkbox" name="localResident" onChange={e=>{this.handleChange(e);this.setState({isSavingLocalResident: true})}} checked={localResident} className="form-check-input" />
                              </div>
                          }
                        </li>
                        :null}
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <div>{t("Language")}</div>
                          {isSavingLanguage?
                            <Loader />
                          :
                            <UncontrolledDropdown>
                              <DropdownToggle caret className="btn btn-sm" tag="div">{user.language?displayedLanguages.find(lang=>lang.name===user.language)&&displayedLanguages.find(lang=>lang.name===user.language).title:t('Select')}</DropdownToggle>
                              <DropdownMenu right>
                                {displayedLanguages.map((language,i)=><DropdownItem key={i} active={user.language===language.name} onClick={()=>this.handleSaveLangauge(language)}>{language.title}</DropdownItem>)}
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          }
                        </li>
                      </ul>
                    </div>
                    <Modal isOpen={modalUserName} toggle={this.modalToggleUserName} centered={true} modalClassName="modal-username">
                      <div className="modal-header">
                        {t("Patron Name")}
                        <button type="button" onClick={this.modalToggleUserName}className="close" aria-label="Close"><span aria-hidden="true">×</span></button>
                      </div>
                      <ModalBody>
                        <form className="row" onSubmit={this.handleSaveName}>
                          <div className="form-group col-sm">
                            <label htmlFor="firstName">{t("First Name")}</label>
                            <input type="text" className={"form-control"} value={firstName} onChange={this.handleChange} name="firstName" />
                          </div>
                          <div className="form-group col-sm">
                            <label htmlFor="lastName">{t("Last Name")}</label>
                            <input type="text" className={"form-control"} value={lastName} onChange={this.handleChange} name="lastName"/>
                          </div>
                        </form>
                        <div className="text-left">
                          <div className="d-flex">
                            <Button className="btn btn-secondary ml-auto" onClick={this.handleSaveName} loading={isSavingName}>{t("Confirm")}</Button>
                          </div>
                        </div>
                      </ModalBody>
                    </Modal>
                    <Modal isOpen={modalUserEmail} toggle={this.modalToggleUserEmail} centered={true} modalClassName="modal-useremail">
                      <div className="modal-header">
                        {t("Patron Email")}
                        <button type="button" onClick={this.modalToggleUserEmail}className="close" aria-label="Close"><span aria-hidden="true">×</span></button>
                      </div>
                      <ModalBody>
                        {emailFormError?
                          <Alert color="danger">{t(emailFormError)}</Alert>
                        :null}
                        <form className="row" onSubmit={this.handleSaveEmail}>
                          <div className="form-group col-sm">
                            <label htmlFor="email">{t("Email")}</label>
                            <input type="text" className={"form-control"} value={email} onChange={this.handleChange} name="email" />
                          </div>
                        </form>
                        <div className="text-left">
                          <div className="d-flex">
                            <Button className="btn btn-secondary ml-auto" onClick={this.handleSaveEmail} loading={isSavingEmail}>{t("Confirm")}</Button>
                          </div>
                        </div>
                      </ModalBody>
                    </Modal>
                    {settings && settings.membershipModule && settings.membershipModule.value=="True"?
                    <div className="card mb-3">
                      <div className="card-body pb-0 border-bottom d-flex justify-content-between align-items-center">
                        <h5 className="card-title">{t("Donor Level")}</h5>
                        <Button className="btn-sm" onClick={this.modalToggleMembership}><FontAwesomeIcon icon={true?['far', 'edit']:'plus'} /></Button>
                      </div>
                        {membership && (membership.membershipExpiration || membership.membershipLevel)?
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <div>{t("Expiration Date")}</div>
                              <div>{membership.membershipExpiration?<Moment format={t("MM/DD/YY")}>{membership.membershipExpiration}</Moment>:"N/A"}</div>
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <div>{t("Paid Until Date")}</div>
                              <div>{membership.membershipPaidUntil?<Moment format={t("MM/DD/YY")}>{membership.membershipPaidUntil}</Moment>:"N/A"}</div>
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <div>{t("Level")}</div>
                              <div>{membership.membershipLevel?membership.membershipLevel:"N/A"}</div>
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <div>{t("Installments")}</div>
                              <div>{membership.membershipInstallments?membership.membershipInstallments:"N/A"}</div>
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <div>{t("Auto-Renew")}</div>
                              <div className="form-check form-switch ml-3">
                                <input type="checkbox" disabled checked={membership.membershipAutoRenew} className="form-check-input" />
                              </div>
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <div>{t("Shower Price")}</div>
                              <div>{typeof membership.membershipPriceShower === 'number'?<CurrencyFormat value={membership.membershipPriceShower} />:"N/A"}</div>
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <div>{t("Bath Price")}</div>
                              <div>{typeof membership.membershipPriceBath === 'number'?<CurrencyFormat value={membership.membershipPriceBath}/>:"N/A"}</div>
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <div>{t("Special Bath Room Price")}</div>
                              <div>{typeof membership.membershipPricePrivateBath === 'number'?<CurrencyFormat value={membership.membershipPricePrivateBath}/>:"N/A"}</div>
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <div>{t("Special Shower Room Price")}</div>
                              <div>{typeof membership.membershipPricePrivateShower === 'number'?<CurrencyFormat value={membership.membershipPricePrivateShower}/>:"N/A"}</div>
                            </li>
                          </ul>
                        :
                        <div className="card-body text-center text-muted small">{t("No Current Level")}</div>
                        }
                      <Modal isOpen={modalMembership} toggle={this.modalToggleMembership} centered={true} modalClassName="modal-delete-card">
                        <div className="modal-header">
                          {t("Patron Donor Level")}
                          <button type="button" onClick={this.modalToggleMembership}className="close" aria-label="Close"><span aria-hidden="true">×</span></button>
                        </div>
                        <ModalBody>
                          {membershipError!==null?
                            <Alert color="danger">{t(membershipError)}</Alert>
                          :null}
                          {updateMembership?
                          <form className="row" onSubmit={this.handleSaveMembership}>
                            <div className="form-group col-sm-6">
                              <label htmlFor="membershipExpiration">{t("Expiration Date")}</label>
                              <div>
                                <DayPickerInput inputProps={{className: 'form-control form-control-datepicker', name: "membershipExpiration", autoComplete: "off"}} formatDate={formatDate} parseDate={parseDate} value={moment(updateMembership.membershipExpiration).toDate()} onDayChange={day => day?this.setState({updateMembership: {...updateMembership, "membershipExpiration": day}}):null} placeholder="MM/DD/YYYY" />
                              </div>
                            </div>
                            <div className="form-group col-sm-6">
                              <label htmlFor="membershipExpiration">{t("Paid Until Date")}</label>
                              <div>
                                <DayPickerInput inputProps={{className: 'form-control form-control-datepicker', name: "membershipPaidUntil", autoComplete: "off"}} formatDate={formatDate} parseDate={parseDate} value={moment(updateMembership.membershipPaidUntil).toDate()} onDayChange={day => day?this.setState({updateMembership: {...updateMembership, "membershipPaidUntil": day}}):null} placeholder="MM/DD/YYYY" />
                              </div>
                            </div>
                            <div className="form-group col-sm-6">
                              <label htmlFor="membershipLevel">{t("Level")}</label>
                              <select className={"form-control"} name="membershipLevel" onChange={this.handleChangeMembership} value={updateMembership && updateMembership.membershipLevel?updateMembership.membershipLevel:'None'}>
                                {membership && membership.membershipLevel?membershipLevels&&membershipLevels.find(l=>l.level===membership.membershipLevel)?null:<option disabled>{membership.membershipLevel}</option>:null}
                                <option>{t("None")}</option>
                                {membershipLevels && membershipLevels.map((option,i)=> {
                                  return <option key={i} value={option.level}>
                                    {option.level}
                                  </option>
                                })}
                              </select>
                            </div>
                            <div className="form-group col-sm-6">
                              <label htmlFor="membershipInstallments">{t("Payment Installments")}</label>
                              <select className={"form-control"} name="membershipInstallments" onChange={this.handleChangeMembership} value={updateMembership && updateMembership.membershipInstallments?t(updateMembership.membershipInstallments):t('None')}>
                                <option disabled>{t("None")}</option>
                                {['Annually'].map((option,i)=> {
                                  return <option key={i} value={option}>
                                    {t(option)}
                                  </option>
                                })}
                              </select>
                            </div>
                            <div className="form-group col-sm-12 d-flex">
                              <label htmlFor="membershipAutoRenew">{t("Auto-Renew")}</label>
                              <div className="form-check form-switch ml-3">
                                  <input type="checkbox" name="membershipAutoRenew" onChange={this.handleChangeMembership} checked={updateMembership && updateMembership.membershipAutoRenew} className="form-check-input" />
                              </div>
                            </div>
                            <div className="col-12 mb-2 border-bottom">{t("Prices")} {siteMembershipLevel?(t('Default Price')):''}</div>
                            <div className="form-group col-sm-6">
                              <label htmlFor="membershipPriceShower">{t("Shower")} {siteMembershipLevel?<>(<CurrencyFormat value={siteMembershipLevel.priceShower} />)</>:''}</label>
                              <input type="text" className={"form-control col-6"} name="membershipPriceShower" onChange={this.handleChangeMembership} value={updateMembership &&updateMembership.membershipPriceShower} />
                            </div>
                            <div className="form-group col-sm-6">
                              <label htmlFor="membershipPriceBath">{t("Bath")} {siteMembershipLevel?<>(<CurrencyFormat value={siteMembershipLevel.priceBath} />)</>:''}</label>
                              <input type="text" className={"form-control col-6"} name="membershipPriceBath" onChange={this.handleChangeMembership} value={updateMembership &&updateMembership.membershipPriceBath} />
                            </div>
                            <div className="form-group col-sm-6">
                              <label htmlFor="membershipPricePrivateShower">{t("Special Shower Room")} {siteMembershipLevel?<>(<CurrencyFormat value={siteMembershipLevel.pricePrivateShower} />)</>:''}</label>
                              <input type="text" className={"form-control col-6"} name="membershipPricePrivateShower" onChange={this.handleChangeMembership} value={updateMembership &&updateMembership.membershipPricePrivateShower} />
                            </div>
                            <div className="form-group col-sm-6">
                              <label htmlFor="membershipPricePrivateBath">{t("Special Bath Room")} {siteMembershipLevel?<>(<CurrencyFormat value={siteMembershipLevel.pricePrivateBath} />)</>:''}</label>
                              <input type="text" className={"form-control col-6"} name="membershipPricePrivateBath" onChange={this.handleChangeMembership} value={updateMembership &&updateMembership.membershipPricePrivateBath} />
                            </div>
                            <div className="text-left col-12">
                              <div className="d-flex">
                                <Button className="btn btn-secondary ml-auto" onClick={this.handleSaveMembership} loading={isSavingMembership}>{t("Confirm")}</Button>
                              </div>
                            </div>
                          </form>
                          :null}
                        </ModalBody>
                      </Modal>
                    </div>
                    :null}

                    {user.phoneNumber.slice(-10)!=='0000000000'?
                    <div className="card mb-3">
                      <div className="card-body pb-0 border-bottom d-flex justify-content-between align-items-center">
                        <h5 className="card-title">{t("Patron Note")}</h5>
                        <Button className="btn-sm" onClick={this.modalToggleUserNote}><FontAwesomeIcon icon={user.notes?['far', 'edit']:'plus'} /></Button>
                      </div>
                      <div className="card-body">
                        {user.notes?
                          <div>{user.notes}</div>
                        :
                          <div className="text-center text-muted small">{t("No patron notes")}</div>
                        }                        
                      </div>

                      <Modal isOpen={this.state.modalUserNote} toggle={this.modalToggleUserNote} centered={true} className={"lang-" + i18n.language} modalClassName="modal-delete-card">
                        <div className="modal-header">
                        {t("Patron Note")}
                          <button type="button" onClick={this.modalToggleUserNote}className="close" aria-label="Close"><span aria-hidden="true">×</span></button>
                        </div>
                        <ModalBody>
                          <div className="form-group">
                            <textarea className="form-control" rows="3" name="userNote" value={userNote?userNote:''} onChange={this.handleChange}/>
                          </div>
                          <div className="text-start">
                            <div className="d-flex">
                              <Button className="btn btn-secondary mis-auto" onClick={this.handleSaveNote} loading={isSavingNote}>{t("Confirm")}</Button>
                            </div>
                          </div>
                        </ModalBody>
                      </Modal>
                    </div>
                    :null}

                    <div className="card mb-3">
                      <div className="card-body pb-0 border-bottom d-flex justify-content-between align-items-center">
                        <h5 className="card-title">{t("Internal Note")}</h5>
                        <Button className="btn-sm" onClick={this.modalToggleInternalNote}><FontAwesomeIcon icon={user.notes?['far', 'edit']:'plus'} /></Button>
                      </div>
                      <div className="card-body">
                        {user.internalNote?
                          <div>{user.internalNote}</div>
                        :
                          <div className="text-center text-muted small">{t("No internal note")}</div>
                        }                        
                      </div>

                      <Modal isOpen={this.state.modalInternalNote} toggle={this.modalToggleInternalNote} centered={true} modalClassName="modal-delete-card">
                        <div className="modal-header">
                        {t("Internal Note")}
                          <button type="button" onClick={this.modalToggleInternalNote}className="close" aria-label="Close"><span aria-hidden="true">×</span></button>
                        </div>
                        <ModalBody>
                          <div className="form-group">
                            <textarea className="form-control" rows="3" name="internalNote" value={internalNote?internalNote:''} onChange={this.handleChange}/>
                          </div>
                          <div className="text-left">
                            <div className="d-flex">
                              <Button className="btn btn-secondary ml-auto" onClick={this.handleSaveInternalNote} loading={isSavingInternalNote}>{t("Confirm")}</Button>
                            </div>
                          </div>
                        </ModalBody>
                      </Modal>
                    </div>

                    {user.phoneNumber.slice(-10)!=='0000000000'?
                    <div className="card mb-3">
                      <div className="card-body pb-0 border-bottom">
                        <h5 className="card-title">{t("Notification Settings")}</h5>
                      </div>
                      <div className="list-group list-group-flush">
                        {[
                          {name: 'notificationReservations', title: 'reservationCreated'},
                          {name: 'notificationDayBefore', title: 'Reservation Day Before'},
                          {name: 'notificationDayOf', title: 'Reservation Day Of'},
                        ].map((notification,i)=>{
                          return <div key={i} className="list-group-item d-flex justify-content-between align-items-center">
                            <div>{t(notification.title)}</div>
                            {isSavingNotification===i?
                              <Loader className="mis-3" />
                            :
                              <div className="form-check form-switch mis-3">
                                <input type="checkbox" name={notification.name} onChange={e=>{this.handleChange(e);this.setState({isSavingNotification:i})}} checked={user[notification.name]} className="form-check-input" />
                              </div>
                            }
                          </div>
                        })}
                      </div>
                    </div>
                    :null}

                    {user.phoneNumber.slice(-10)!=='0000000000'?
                    <div className="card mb-3">
                      <div className="card-body pb-0 border-bottom d-flex justify-content-between align-items-center">
                        <h5 className="card-title">{t("Excluded Attendants")}</h5>
                        <Button className="btn-sm" onClick={this.modalToggleAddAttendant}><FontAwesomeIcon icon="plus" /></Button>
                      </div>
                      {isLoadingAttendants?
                        <Loader />
                      :
                        <>
                          {attendants&&attendants.length?
                            <>
                              {(user.excludedAttendants?
                                <>
                                  <ul className="list-group list-group-flush">
                                    {user.excludedAttendants.map((ea,i)=>{
                                      let att = attendants.find(att=>att.id===ea.attendantId);
                                      return <div key={i} className="list-group-item d-flex justify-content-between align-items-center">
                                        <div>{att&&att.name}</div>
                                        <Button className="btn-sm" onClick={()=>this.setState({selectedRemoveAttendant:att,modalRemoveAttendant:true})}><FontAwesomeIcon icon={['far', 'trash-alt']} /></Button>
                                      </div>
                                    })}
                                  </ul>

                                  <Modal isOpen={this.state.modalRemoveAttendant} toggle={this.modalToggleRemoveAttendant} centered={true} className={"lang-" + i18n.language} modalClassName="modal-delete-card">
                                    <div className="modal-header">
                                    {t("Remove Excluded Attendant")}
                                      <button type="button" onClick={this.modalToggleRemoveAttendant}className="close" aria-label="Close"><span aria-hidden="true">×</span></button>
                                    </div>
                                    <ModalBody>
                                      <div className="text-start">
                                        <p>{t("Are you sure you want to remove this excluded attendant?")}</p>
                                        <div className="d-flex">
                                          <Button className="btn btn-secondary mis-auto" onClick={this.handleRemoveAttendant} loading={isSavingAttendant}>{t("Confirm")}</Button>
                                        </div>
                                      </div>
                                    </ModalBody>
                                  </Modal>
                                </>
                              :
                                <div className="card-body text-center text-muted small">{t("No excluded attendants")}</div>
                              )}

                              <Modal isOpen={this.state.modalAddAttendant} toggle={this.modalToggleAddAttendant} centered={true} className={"lang-" + i18n.language} modalClassName="modal-delete-card">
                                <div className="modal-header">
                                {t("Add Excluded Attendant")}
                                  <button type="button" onClick={this.modalToggleAddAttendant}className="close" aria-label="Close"><span aria-hidden="true">×</span></button>
                                </div>
                                <ModalBody>
                                  <div className="text-start">
                                    {user.excludedAttendants && user.excludedAttendants.length > 1 && !overrideMaxExcluded?
                                    <>
                                    <p>{t("maximumExcludedAtteandantsExceeded")}</p>
                                    <div className="d-flex">
                                      <Button className="btn btn-secondary mis-auto" onClick={() => this.setState({overrideMaxExcluded: true})}>{t("Manager Override")}</Button>
                                    </div>
                                    </>
                                    :
                                    <>
                                    <p>{t("Choose an attendant to exclude for this patron.")}</p>
                                    <UncontrolledDropdown>
                                      <DropdownToggle caret>{this.state.selectedAddAttendant?this.state.selectedAddAttendant.name:'Select Attendant'}</DropdownToggle>
                                      {attendants&&attendants.length?
                                        <DropdownMenu>
                                          {attendants.map((s,i)=>{
                                            if(!user.excludedAttendants.find(e => e.attendantId===s.id)){
                                              return <DropdownItem key={i} onClick={()=>this.setState({selectedAddAttendant:s})}>{s.name}</DropdownItem>
                                            }
                                          })}
                                        </DropdownMenu>
                                      :null}              
                                    </UncontrolledDropdown>
                                    <div className="d-flex">
                                      <Button className="btn btn-secondary mis-auto" onClick={this.handleAddAttendant} loading={isSavingAttendant}>{t("Confirm")}</Button>
                                    </div>
                                    </>
                                    }
                                    </div>
                                </ModalBody>
                              </Modal>
                            </>
                          :
                            <div className="card-body text-center text-muted small">{t("No attendants")}</div>
                          }
                        </>
                      }
                    </div>
                    :null}
                    {user.phoneNumber.slice(-10)!=='0000000000'?
                    <div className="card mb-3">
                      <div className="card-body pb-0 border-bottom">
                        <h5 className="card-title">{t("Saved Cards")}</h5>
                      </div>
                      {isLoadingSavedCards?
                        <Loader />
                      :
                        (savedCards&&savedCards.length ?
                          <>
                            <ul className="list-group list-group-flush">
                              {savedCards.map((card,i) => <div key={i} className="list-group-item d-flex justify-content-between align-items-center">
                                <div>
                                  {cardBrands[card.brand.toUpperCase()]?<FontAwesomeIcon className="mie-2" icon={cardBrands[card.brand.toUpperCase()].icon} />:null}
                                  {card.brand} ••••{card.last4}</div>
                                <Button className="btn-sm" onClick={()=>this.setState({selectedDeleteCard:card,modalDeleteCard:true})}><FontAwesomeIcon icon={['far', 'trash-alt']} /></Button>
                              </div>)}
                            </ul>

                            <Modal isOpen={this.state.modalDeleteCard} toggle={this.modalToggleDeleteCard} centered={true} className={"lang-" + i18n.language} modalClassName="modal-delete-card">
                              <div className="modal-header">
                              {t("Delete Card")}
                                <button type="button" onClick={this.modalToggleDeleteCard}className="close" aria-label="Close"><span aria-hidden="true">×</span></button>
                              </div>
                              <ModalBody>
                                <div className="text-start">
                                  <p>{t("Are you sure you want to delete this card?")}</p>
                                  <div className="d-flex">
                                    <Button className="btn btn-secondary mis-auto" onClick={this.handleDeleteSavedCard} loading={isSavingCards}>{t("Confirm")}</Button>
                                  </div>
                                </div>
                              </ModalBody>
                            </Modal>
                          </>
                        :
                          <div className="card-body text-center text-muted small">{t("No saved cards")}</div>
                        )
                      }
                    </div>
                    :null}
                  </div>
                </div>
                {selectedReservation!==null?
                  <ReservationDetails modalToggle={()=>this.setState({selectedReservation:null})} handleReservationUpdated={(s) => this.handleReservationUpdated(s)} locations={this.props.localProps.locations} siteSettings={this.props.siteSettings} reservation={reservations[selectedReservation]} />
                :null}
              </>
            }
            </>
            :<Loader/>}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ReceptionistUserView);

function ReservationsTable(props) {
  const { t, attendants } = props;
  const privateRooms = {"private-bath":iconBathPrivate, "private-shower": iconShowerPrivate}
  const columns = React.useMemo(
    () => [
      {
        Header: t("Date"),
        accessor: "reservationDate",
        sortDescFirst: true,
        sortType: (a, b) => {
          var a1 = moment(a.original.reservationTime).valueOf();
          var b1 = moment(b.original.reservationTime).valueOf();
        if(a1<b1)
        return 1;
        else if(a1>b1)
        return -1;
        else
        return 0;
        },
        Cell: ({row}) => {
          const res = row.original;
          return (
          <>
            <Moment format={t("MM/DD/YY")}>{res.reservationTime}</Moment>
            <HebrewDate className="mis-1" date={res.reservationTime} day={true} month={true}/>
          </>
          )
        }
      },
      {
        Header: t("Status"),
        accessor: "reservationStatus",
        Cell: ({row}) => {
          const res = row.original;
          return t(statuses[res.reservationStatus].name)
        },
      },
      {
        Header: t("Type"),
        accessor: "type",
        Cell: ({row}) => {
          const res = row.original;
          return <>
            {res.segula?<ReactSVG className="icon-segula" src={iconSegula} />:res.privateRoom?<ReactSVG className="icon-private" src={privateRooms[res.roomType]} />:<FontAwesomeIcon icon={res.kallah?['far','gem']:res.roomType} />}
            {!res.advanceReservation?<ReactSVG className="icon-walkin mis-2" src={iconWalkin} />:null} 
            {res.parking?<FontAwesomeIcon className="icon mis-2" icon="car" />:null}
            {res.doubleSlot||res.hasExtraTime?<FontAwesomeIcon className="icon mis-2" icon={["far", "clock"]} />:null}
            {res.salonManicure||res.salonBoth?<FontAwesomeIcon className="icon mis-2" icon="paint-brush" />:null}
          </>
        },
        sortType: (a, b) => {
          var a1 = a.original.kallah?'kallah':a.original.roomType;
          var b1 = b.original.kallah?'kallah':b.original.roomType;
        if(a1<b1)
        return 1;
        else if(a1>b1)
        return -1;
        else
        return 0;
        },
      },
      {
        Header: t("Balance"),
        accessor: "balance",
        Cell: ({row}) => {
          const res = row.original;
          return res.paid?t('Paid'):<CurrencyFormat value={res.balance} />
        }
      },
      {
        Header: t("AttendantTevilah"),
        accessor: "attendantId",
        Cell: ({row}) => {
          const res = row.original;
          let atttevilah = attendants && attendants.find(att=>att.id===res.attendantId);
          return atttevilah?atttevilah.name:null
        }
      },
      {
        Header: t("Room"),
        accessor: "roomId",
        Cell: ({row}) => {
          const res = row.original;
          return res.room!=null?res.room.id:(['Done', 'Canceled'].includes(res.reservationStatus)?res.roomId:res.roomIdPreassign?t("Pre")+"-"+res.roomIdPreassign:null)
        },
        sortType: (a, b) => {
          var a1 = a.original.room!=null?a.original.room.id:(['Done', 'Canceled'].includes(a.original.reservationStatus)?a.original.roomId:a.original.roomIdPreassign?a.original.roomIdPreassign:null);
          var b1 = b.original.room!=null?b.original.room.id:(['Done', 'Canceled'].includes(b.original.reservationStatus)?b.original.roomId:b.original.roomIdPreassign?b.original.roomIdPreassign:null);
        if(a1<b1)
        return 1;
        else if(a1>b1)
        return -1;
        else
        return 0;
        },
      },
      {
        Header: t("Notes"),
        accessor: "notes",
        Cell: ({row}) => {
          const res = row.original;
          return <>{res.notes!=null||res.user.notes?<FontAwesomeIcon icon={['far', 'sticky-note']} />:null}
          {res.user.excludedAttendants.length>0?<ReactSVG className="icon-excluded mis-2" src={iconExcludedAttendant} alt="Excluded Attendant Icon"/>:null}
          </>
        },
        sortType: (a, b) => {
          var a1 = !!(a.original.notes || a.original.user.notes);
          var b1 = !!(b.original.notes || b.original.user.notes);
        if(a1<b1)
        return 1;
        else if(a1>b1)
        return -1;
        else
        return 0;
        },
      },
      ],
    []
  )
  const data = useMemo(()=>{
    return props.data ? props.data : [{}]
}, [props.data]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  },useSortBy);

  return (
    <table className="table" {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => {
              return (<th className={(column.isSorted?"sort":"")+(column.canSort?" canSort":"")} {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render("Header")}
              </th>
            )})}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {data.length?
        rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()} className="clickable"  onClick={(e) => props.viewReservation(row.original.reservationId)}>
              {row.cells.map((cell) => {
                return <td {...cell.getCellProps()} className={cell.column.Header=="SMS"?"smsCheckbox":""}>{cell.render("Cell")}</td>;
              })}
            </tr>
          );
        })
        :<tr>
            <td colSpan="10" className="text-center">{t("No reservations found.")}</td>
          </tr>
        }
      </tbody>
    </table>
  );
}
